import Chunklets from 'components/Content/Happening/StoreDetails/Chunklets/Chunklets';
import { withHappeningUserProps } from 'viewModel/happening/withHappeningUserProps';

export default withHappeningUserProps(Chunklets);
